import React from 'react';
import { ValidationColumn, FpcModel } from '../../models/models';

import './Results.css';

interface ResultProps {
    model: FpcModel;
}

interface ResultState {
    fpc: FpcModel;

}

class Result extends React.Component<ResultProps, ResultState> {


    constructor(props: ResultProps) {
        super(props);

        this.state = {
            fpc: props.model,

        }

    };


    render() {
        let fpc = this.state.fpc;
        return (
            <div className='fpcResultsDiv'>
                <br />
                <table className="resultsTable">
                    <thead>
                        <tr>
                            {fpc.ResultData.Columns.map((col: ValidationColumn, index:number) => <th key={index}>{col.name}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {fpc.ResultData.Data.map((row, index:number) => <tr key={index}>{fpc.ResultData.Columns.map((col: ValidationColumn, index:number) => <td key={index}>{row[col.name]}</td>)}</tr>)}
                    </tbody>
                </table>
            </div>
        )
    };

}

export default Result;